import { render, staticRenderFns } from "./AdminInvoiceShowTabular.vue?vue&type=template&id=d8b3fa5c&scoped=true&"
import script from "./AdminInvoiceShowTabular.vue?vue&type=script&lang=ts&"
export * from "./AdminInvoiceShowTabular.vue?vue&type=script&lang=ts&"
import style0 from "./AdminInvoiceShowTabular.vue?vue&type=style&index=0&id=d8b3fa5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b3fa5c",
  null
  
)

export default component.exports